// extracted by mini-css-extract-plugin
module.exports = {"container":"_37VvUVaFB0","icon":"_3h5kQxAImR","title-section-container":"_2XqTxKCzkJ","titleSectionContainer":"_2XqTxKCzkJ","title-section":"_6u1TkUqdSx","titleSection":"_6u1TkUqdSx","title":"HOtGM1N3jG","id":"_3rpfUU5Zfp","id-prefix":"_35jMZZCLmO","idPrefix":"_35jMZZCLmO"};
    if(module.hot) {
      // 1614934747267
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  